export const LUX_LOYALTY = {
  PROGRAM_NAME: 'LuxLoyalty',
  LANDING_PAGE: 'lux-loyalty',
  DISMISS_JOIN_MODAL_STORAGE_KEY: 'luxLoyalty.dismissJoinModal',
  DEFAULT_TIER: 'bronze',
} as const
